import { createContext, useContext, type JSX, type ReactNode } from 'react';

import { useRegistryTree, type RegistryTreeState } from './useRegistryTree.js';

const RegistryTreeContext = createContext<RegistryTreeState>({
  groups: [],
  loading: true,
  error: null,
});

export interface RegistryTreeProviderProps {
  /** Staff access token — forwarded as the bearer on the registry request. */
  accessToken: string | null | undefined;
  children: ReactNode;
}

/**
 * Fetches the role-filtered registry tree once (with the staff access token) and shares it with
 * the left nav and any page that renders the catalog — so a shell + a launcher home don't each
 * fire their own identical request.
 */
export function RegistryTreeProvider({
  accessToken,
  children,
}: RegistryTreeProviderProps): JSX.Element {
  const state = useRegistryTree(accessToken);
  return <RegistryTreeContext.Provider value={state}>{children}</RegistryTreeContext.Provider>;
}

/** Reads the shared registry-tree state provided by {@link RegistryTreeProvider}. */
export function useRegistryTreeContext(): RegistryTreeState {
  return useContext(RegistryTreeContext);
}
